<template>
    <div class="container">

        <div class="row distance">
            <div class="twelve columns">
                <article>
                    <h1><small>Datenschutz&shy;erklärung</small></h1>

                    <div class="row">
                        <div class="six columns">
                            <h2><small>1. Datenschutz</small></h2>
                            <p>Ich erfasse keine personenbezogenen Daten auf dieser Homepage.</p>
                            <p>Ich verwende keine Cookies, keine "Tracking" Tools, keine Werbung oder sonst irgend einen Daten sammelnden Mechanismus.</p>

                            <h2><small>2. Server-Log Files</small></h2>
                            <p>Allerdings speichert mein Web-Hoster so genannte "Server-Log Files", auf die ich jederzeit zugreifen kann.</p>
                            <p>Server-Log Files sind Dateien, in denen jeder Aufruf meiner Homepage protokolliert wird,
                                wobei die IP Adressen der Aufrufer anonymisiert werden - somit ist eine Zuordnung zu einzelnen Personen nicht mehr möglich.
                            </p>
                            <!--
                                <h2>Server-Log-Files:</h2>
                                <p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log Files,
                                die Ihr Browser automatisch an meine Webseiten übermittelt.
                                Dies sind:</p>
                                <ul>
                                    <li>Browsertyp/ Browserversion</li>
                                    <li>verwendetes Betriebssystem</li>
                                    <li>Referrer URL</li>
                                    <li>Hostname des zugreifenden Rechners</li>
                                    <li>Uhrzeit der Serveranfrage</li>
                                </ul>
                                <p>Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
                                Ich behalte mir vor, diese Daten nachträglich zu prüfen, wenn mir konkrete Anhaltspunkte für eine rechtswidrige Nutzung bekannt werden.</p>
                                <p> </p>
                            -->
                            <p></p>
                        </div>
                    </div>

                </article>
            </div>
        </div>

    </div><!-- div.container -->
</template>

<script>
export default {
    name: 'PageDatenschutz'
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/pages/PageDatenschutz.vue